module.exports = __webpack_public_path__ + "img/3.caa1f256.webp";